import './StatusPage.css';
import StatusForm from './form';

const StatusFrom = () => {
  return <StatusForm />;
};

export default StatusFrom;
